import { toArray as e } from "../formatting/toArray.js";
const b = (u, s = !1) => {
  var l, o;
  const a = e(u);
  return s ? a.map((r) => (r == null ? void 0 : r.value) ?? (r == null ? void 0 : r.label)) : ((l = a[0]) == null ? void 0 : l.value) ?? ((o = a[0]) == null ? void 0 : o.label);
};
export {
  b as getValueFromLabelValues
};
